<div class="color-dropdown">
  <app-dropdown hPosition="left" scrollHeight="250px" itemWidth="200px" styleClassSelectedView="p-0" styleClassDropdownListItem="p-0"
    [focusOnSelectedValue]="false" [options]="options" [isDropdownIconVisible]="false" [hasCustomOpenTemplate]="true"
    [hasCustomItemTemplate]="true" (appSelect)="selectColor($event.value)">
    <ng-template let-item appTemplate="open-dropdown-btn">
      <div class="color-dropdown-btn flex-center-center" [ngStyle]="{ 'background-color': value }">
        <i id="app-color-dropdown-btn" class="fal fa-angle-down"></i>
      </div>
    </ng-template>

    <ng-template let-item appTemplate="item">
      <div class="appt-color-wrapper flex-between-center flex-row pr-2 pl-2 pt-1 pb-1"  (mouseenter)="showTrashIcon($event, item)"  >
        <div class="appt-color-label text-truncate">
          <span  [ngClass]="{ 'font-bold': item?.value === value }">{{ item?.label }}</span>
        </div>

        <div class="appt-color-edit flex-center-center">
          <i class="far fa-pencil font-12 p-1" (click)="showEditOption($event, item)"></i>
        </div>
        <div class="appt-color-edit flex-center-center" *ngIf="!isShowTrashIcon">
          <i class="far fa-trash-alt font-12 p-1" (click)="deleteColor(item._id)"></i>
        </div>
        <div class="appt-color-circle">
          <div class="color flex-center-center" [ngStyle]="{ 'background-color': item?.value }">
            <i *ngIf="item?.value === value" class="far fa-check font-8 font-white"></i>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template let-item appTemplate="footer">
      <div class="add-color-label flex-column" *ngIf="!isAddMode" (click)="handleAddColor($event)">
          <span class="ml-1 p-1 font-bold font-12 font-autoleap-green pointer">Add new color</span>
      </div>
      <div class="add-color-label flex-column" *ngIf="isAddMode">
        <div class="bottom-border-label">
          <app-input theme="light" placeholder="Enter color name" [fontSize]="12" [errorMessage]="validate.colorName"
          [isInvalid]="validate.colorName" [hasBorderBottomOnActive]="true" [value]="editableColor.label"
          (appChange)="handleChangeLabel($event)">
          </app-input>
        </div>
        <div class="bottom-border-label"  [ngClass]="{'mt-3': validate.colorName}"  *ngIf="isColorNew || (isColorEdited && !isHideColorValue  )">
          <app-input theme="light" placeholder="Select color" [fontSize]="12" [hasBorderBottomOnActive]="true" [colorCircle]="true" [colorValue]="editableColor.value"  [value]="editableColor.value"
          (appChange)="handleChangeValue($event)" [style.background]="editableColor.value" [cpOKButton]="true" [cpOutputFormat]="'hex'"  [cpOKButtonText] = "'Apply'"
          [cpOKButtonClass]="'btn btn-primary font-12'" [errorMessage]="validate.colorValue"
          [isInvalid]="validate.colorValue" [(colorPicker)]="editableColor.value" [cpPosition]="'auto'"  >
          </app-input>
        </div>

        <div class="text-right mt-4 mb-2 ">
          <button class="btn btn-white btn-width mr-2 font-12" (click)="handleCancel($event)">Cancel</button>
          <button class="btn btn-primary btn-width mr-2 font-12" (click)="handleSave($event)">Save</button>
        </div>
      </div>
    </ng-template>
  </app-dropdown>
</div>
